module.exports = __webpack_public_path__ + "static/media/icons-vr-icon.586a2686.svg";